
import React, { useState } from "react";
import { API_BASE_URL } from "../api";
import { Link } from "react-router-dom";
import { ArrowRight, Instagram, Send, Twitter } from "lucide-react";

function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const brandLogoSrc = `${process.env.PUBLIC_URL}/mekedge-logo.svg`;

  const subscribe = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");
    if (!email || !email.includes("@")) {
      setError("Please enter a valid email.");
      return;
    }
    setLoading(true);
    try {
  const res = await fetch(`${API_BASE_URL}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess(data.message || "Subscribed!");
        setEmail("");
      } else {
        setError(data.error || "Subscription failed.");
      }
    } catch {
      setError("Network error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <footer className="mt-16 border-t border-black/5 bg-[#111827] text-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-14 md:grid-cols-3 lg:px-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={brandLogoSrc}
              alt="MekEdge logo"
              className="h-11 w-11 object-contain"
            />
            <div>
              <h2 className="text-2xl font-semibold tracking-tight">MekEdge</h2>
                <p className="text-xs uppercase tracking-[0.28em] text-slate-400">Trading journal and analytics</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-8 text-slate-300">
              A trading journal and analytics platform for traders who want clearer reviews, better discipline, and a stronger performance record.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li><Link to="/about" className="text-slate-300 transition hover:text-white">About</Link></li>
            <li><Link to="/pricing" className="text-slate-300 transition hover:text-white">Pricing</Link></li>
            <li><Link to="/faq" className="text-slate-300 transition hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="text-slate-300 transition hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Stay Updated</h3>
          <p className="mb-4 text-sm leading-7 text-slate-300">
            Subscribe for product updates, new features, and useful trading insights from MekEdge.
          </p>
          <form className="flex flex-col sm:flex-row gap-2" onSubmit={subscribe}>
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="flex-1 rounded-full border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-400"
              required
            />
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-slate-950 transition hover:bg-slate-200"
              disabled={loading}
            >
              <Send className="h-4 w-4" />
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          {error && <div className="text-rose-300 text-sm mt-2" role="alert">{error}</div>}
          {success && <div className="text-emerald-300 text-sm mt-2" role="status">{success}</div>}
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 border-t border-white/10 px-6 py-6 md:flex-row lg:px-10">
        <p className="text-sm text-slate-400">
          © {new Date().getFullYear()} MekEdge. All rights reserved - Operated by MekEdge LTD. (RC No. 8976419). Registered in Nigeria. All rights reserved.
        </p>
        <div className="flex items-center gap-4">
          <Link to="/signup" className="inline-flex items-center gap-2 text-sm font-semibold text-white transition hover:text-slate-200">
            Create account
            <ArrowRight className="h-4 w-4" />
          </Link>
          <a href="https://x.com/mekedge?t=-1DBKXn973HyoH1dY2BEPw&s=09" target="_blank" rel="noreferrer" className="text-slate-400 transition hover:text-white">
            <Twitter className="w-5 h-5" />
          </a>
          <a href="https://t.me/mekedge" target="_blank" rel="noreferrer" className="text-slate-400 transition hover:text-white">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 4L2 12.5L8.5 14.5L10.5 19L13.5 15.5L19 20L22 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/mekedge_?igsh=MWFhZWUwcmI3a3Ywcg==" target="_blank" rel="noreferrer" className="text-slate-400 transition hover:text-white">
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;